module.exports = {
  // 订单-在线订单
  // 订单-离线导出
  exportOfflineOrderList: "/api/order/exportExcelByOfflineOrderList",
  exportOfflineOrderListV1: "/ant/api/order/exportExcelByOfflineOrderListV1",
  // 订单-在线导出
  exportChargeOrderList: "/api/order/exportExcelByChargeOrderList",
  exportExcelByChargeOrderListV1:
    "/ant/api/order/exportExcelByChargeOrderListV1",
  // 订单-在线订单
  queryChargeOrderList: "/ant/api/order/queryChargeOrderList",
  // 订单-订单详情
  queryOrderDetai: "/ant/api/order/queryOrderDetail",
  // 订单- 统计站点不同金额与实付金额统计
  getSiteAmountDetail: "/ant/api/dataReport/getSiteAmountDetail",
  // 订单详情展开收起
  queryOrderTimeDivisionList: "/ant/api/order/queryOrderTimeDivisionList",
  // 订单-离线订单
  queryOfflineOrderList: "/ant/api/order/queryOfflineOrderList",
  // 订单-订单概况
  getOrderTimeDivisionData: "/ant/api/order/getOrderTimeDivisionData",
  // 订单-订单概况（优）
  getOrderTimeDivisionStatisticsData:
    "/ant/api/dataReport/getOrderTimeDivisionStatisticsData",
  // 订单-重置订单
  modifyChargerOrderByHand: "/ant/api/order/modifyChargerOrderByHand",
  // 订单-重置订单
  modifyChargerOrderByHandV1: "/ant/api/order/modifyChargerOrderByHandV1",
  // 设置
  // 获取充电设置信息
  selectChargeConfInfo: "/ant/api/chargerConf/selectChargeConfInfo",
  // 充电设置保存
  updateChargeConf: "/ant/api/chargerConf/updateChargeConf",
  // 查询界面设置
  getCustomUi: "/ant/api/merchant/getCustomUi",
  // 界面设置保存接口
  // 'customUiSaveOrUpdate': '/ant/api/merchant/customUiSaveOrUpdate',
  // 获取充值设置信息
  selectRechargeInfo: "/ant/api/recharge/selectRechargeInfo",
  // 保存充值设置信息
  addRechargeInfo: "/ant/api/recharge/addRechargeInfo",

  //
  // 营销-分页获取计费模板列表 /站点-分页获取计费模板列表
  getPagedTemplateInfoList: "/ant/api/template/getPagedTemplateInfoList",
  // 根据ID获取计费模板详
  getTemplateDetailById: "/dbs/api/temp营销late/getTemplateDetailById",
  // 营销-新增计费模板
  insertTemplate: "/dbs/api/template/insertTemplate",
  // 营销-广告列表
  listAdInfos: "oms/api/ad/listAdInfos",
  // 营销-广告 获取商户及其子商户列表
  listCommRelByCommId: "/oms/api/ad/listCommRelByCommId",
  // 营销-广告 根据商户id 判断商户是否拥有小程序
  haveWXAppOrNot: "oms/api/ad/haveWXAppOrNot",
  // 广告更新优先级
  updateSerial: "/oms/api/ad/updateSerial",
  // 获取地理纬度省市信息
  getGeography: "/oms/api/ad/getGeography",
  // 停止广告接口
  adStop: "/oms/api/ad/adStop",
  // 新增广告
  saveAdvert: "/oms/api/ad/saveAdvert",
  // 更新广告
  updateByAdId: "/oms/api/ad/updateByAdId",
  // 根据id查询广告详情
  getAdDetail: "/oms/api/ad/getAdDetail",
  // 日志
  // 日志-操作日志
  queryOperationPage: "/ant/api/esDevice/queryPage",
  // 客户管理导出
  clientManageExport: "/ant/api/user/clientManageExport",
  // 客户组折扣
  // 根据条件分页查询用户组优惠列表
  queryDiscountPageList: "/ant/api/discount/queryDiscountPageList",
  // 根据id查询用户组优惠
  getDiscount: "/ant/api/discount/getDiscount",
  // 更新用户组优惠
  updateDiscount: "/ant/api/discount/updateDiscount",
  // 用户组历史版本
  getDiscountListByCode: "/ant/api/discount/getDiscountListByCode",
  // 增加用户组优惠
  addDiscount: "/ant/api/discount/addDiscount",
  // 获取站点信息
  getSiteSelectInfoList2: "/ant/api/site/getSiteSelectInfoList",
  // 根据条件分页查询客户分组列表
  getUserGroupList: "/ant/api/userGroup/getUserGroupList",
  getUserGroupDiscountByUser: "/ant/api/discount/getUserGroupDiscountByUser",

  // 界面设置-查询当前商户设置
  getCurrentCustomUi: "/ant/api/customUi/getCurrentCustomUi",
  // 商户设置-查询商户设置
  getCommIdCustomUi: "/ant/api/customUi/getCustomUi",
  // 商户设置-界面设置--保存接口
  customUiSaveOrUpdate: "/ant/api/customUi/customUiSaveOrUpdate",

  // 财务
  // 财务-财务统计
  financeSurvey: "/ant/api/finance/financeSurvey",
  // 财务-充电运营走势
  financeDaySurvey: "/ant/api/finance/daySurvey",
  // 财务-充电运营走势(优化)
  getFinancialOperatingTrend: "/ant/api/finance/getFinancialOperatingTrend",
  // 财务-流水记录
  queryPipelineRecord: "/ant/api/finance/queryPipelineRecord",
  // 财务-流水记录
  queryPayMentList: "/ant/api/finance/queryPayMentList",
  // 财务- 退款事宜
  // 查询用户退款记录列表（余额退款 和保证金退款）
  queryListbyPhone: "/ant/api/offlineRefund/queryListbyPhone",
  // 查询线下退款详情
  queryById: "/ant/api/offlineRefund/queryById",
  // 客服审核退款
  audit: "/ant/api/offlineRefund/audit",
  // 财务进行的退款
  operate: "/ant/api/offlineRefund/operate",
  // 概况
  // 概况-运营概况（ 废弃 ）
  analysisGet: "/ant/api/analysis/get",
  // 概况-用电量统计接口
  dataReportGetYDL: "/ant/api/dataReport/getYDL",
  // 概况-客户统计概览接口
  analysisGetkhtjgl: "/ant/api/analysis/getkhtjgl",
  // 概况-客户统计柱状图接口
  analysisGetkhtjzzt: "/ant/api/analysis/getkhtjzzt",
  // 概况-客户增长走势接口
  analysisGetkhzzzs: "/ant/api/analysis/getkhzzzs",
  // 概况-查询月份及对应的用电量接口（用电量统计概览柱状图）
  getElectricityByMonth: "/ant/api/analysis/getElectricityByMonth",
  // 概况-用电量统计接口
  analysisGetydltj: "/ant/api/analysis/getydltj",
  // 概况-用电量走势接口
  analysisGetydlzs: "/ant/api/analysis/getydlzs",
  // 概况-站点统计概览接口
  siteGetzdtjgl: "/ant/api/analysis/getzdtjgl",
  // 概况-站点统计柱状图接口
  siteGetzdtjzzt: "/ant/api/analysis/getzdtjzzt",
  // 概况-充电站昨日充电量排名
  analysisGetrcdlpm: "/ant/api/analysis/getrcdlpm",
  // 概况-订单统计概览
  analysisGetddtjgl: "/ant/api/analysis/getddtjgl",
  // 概况-订单走势接口
  analysisGetddzs: "/ant/api/analysis/getddzs",
  // 概况-订单走势接口
  getOrderCountByMonth: "/ant/api/analysis/getOrderCountByMonth",

  // 客户
  // 客户-客户详情-交易记录-交易状态初始化
  offline: "/ant/api/offlineRefund/offlineByUser",
  // 客户-离线卡列表
  offLineCardList: "/ant/api/card/offLineCardList",
  // 客户-离线卡添加
  addOffLineCard: "/ant/api/card/addOffLineCard",
  // 客户-离线卡删除
  deleteOffLineCard: "/ant/api/card/deleteOffLineCard",
  // 客户-离线卡加入黑名单
  pullBlack: "/ant/api/card/pullBlack",
  // 客户-离线卡移除黑名单
  removeBlack: "/ant/api/card/removeBlack",
  // 客户-鉴权卡列表
  queryCards: "/ant/api/card/queryCards",
  // 客户-鉴权卡激活
  activateAuthCard: "/ant/api/card/activateAuthCard",
  // 客户-鉴权卡删除
  deleteAuthCard: "/ant/api/card/deleteAuthCard",
  // 客户-鉴权卡挂失
  lockAuthCard: "/ant/api/card/lockAuthCard",
  // 客户-鉴权卡获取站点
  getSiteSelectInfoList: "/dbs/api/site/getSiteSelectInfoList",
  // 客户-鉴权卡加入黑名单
  blackAuthCard: "/ant/api/card/blackAuthCard",
  // 客户-鉴权卡解除黑名单
  unBlackAuthCard: "/ant/api/card/unBlackAuthCard",
  // 客户-鉴权卡充值
  rechargeAuthCard: "/ant/api/card/rechargeAuthCard",
  // 客户-鉴权卡添加
  addAuthCard: "/ant/api/card/addAuthCard",
  // 客户-鉴权卡回显
  queryCardById: "/ant/api/card/queryCardById",
  // 客户-鉴权卡更新
  updateAuthCard: "/ant/api/card/updateAuthCard",
  // 客户-客户列表
  queryUsers: "/ant/api/user/queryUsers",
  // 客户-客户列表充值
  addBalance: "/ant/api/balance/addBalance",
  // 客户-客户列表加入黑名单
  userToBlack: "/ant/api/user/userToBlack",
  // 客户-客户列表解除黑名单
  userUnBlack: "/ant/api/user/userUnBlack",
  // 客户-客户列表获取余额
  toRecharger: "/ant/api/user/toRecharger",
  // 客户-客户详情-基本信息
  findByUserId: "/ant/api/user/findByUserId",
  // 客户-客户详情-订单
  queryChargeOrderListAll: "/ant/api/order/queryChargeOrderListAll",
  // 客户-客户详情-充值提现
  findBalanceRecords: "/ant/api/balance/findBalanceRecords",
  // 客户-客户详情-开启多笔订单
  openMultiOrder: "/ant/api/user/openMultiOrder",
  // 客户-集团客户列表
  queryBlocUser: "/ant/api/blocUser/queryBlocUser",
  // 客户-集团客户充值
  addBlocWallet: "/ant/api/BlocWallet/addBlocWallet",
  // 客户-集团客户删除
  deleteRBlocUserById: "/ant/api/rblocUser/deleteRBlocUserById",
  deleteBlocUserById: "/ant/api/blocUser/deleteBlocUserById",
  // 客户-集团客户列表查询
  queryRBlocUser: "/ant/api/rblocUser/queryRBlocUser",
  // 客户-查询集团详情接口
  getBlocUserByBlocUserId: "/ant/api/blocUser/getBlocUserByBlocUserId",
  // 新增集团
  insertBlocUser: "/ant/api/blocUser/insertBlocUser",
  // 客户-更新集团
  updateBlocUser: "/ant/api/blocUser/updateBlocUser",
  // 新增集团客户
  insertRBlocUser: "/ant/api/rblocUser/insertRBlocUser",
  // 更新集团客户
  updateRBlocUser: "/ant/api/rblocUser/updateRBlocUser",
  // 客户-鉴权卡交易记录
  getBalanceRecordList: "/ant/api/card/getBalanceRecordList",
  // 集团客户车辆列表
  blocUserCarlist: "/ant/api/blocUserCar/blocUserCarlist",
  // 保存集团客户车辆
  saveBlocUserCar: "/ant/api/blocUserCar/saveBlocUserCar",
  // 更新客户车辆列表
  updateBlocUserCar: "/ant/api/blocUserCar/updateBlocUserCar",
  // 集团客户车辆详情
  blocUserCarDetail: "/ant/api/blocUserCar/blocUserCarDetail",
  // 删除集团客户车辆
  deleteBlocUserCar: "/ant/api/blocUserCar/deleteBlocUserCar",

  // 客户组
  // 客户组列表
  queryUserGroupList: "/ant/api/userGroup/queryUserGroupList",
  // 客户分组详情
  queryUserGroupById: "/ant/api/userGroup/queryUserGroupById",
  // 获取未分组的客户列表
  queryNegationUsers: "/ant/api/userGroup/queryNegationUsers",
  // 获取未分组的客户列表(分页)
  findUserListNotInGroupId: "/ant/api/userGroup/findUserListNotInGroupId",
  // 获取所属用户列表(分页)
  findUserListByGroupId: "/ant/api/userGroup/findUserListByGroupId",
  // 添加客户组
  addUserGroup: "/ant/api/userGroup/addUserGroup",
  // 编辑客户组
  updateUserGroup: "/ant/api/userGroup/updateUserGroup",

  // 站点模块
  // 站点-站点列表
  getPagedSiteSimpleList: "/ant/api/site/getPagedSiteSimpleList",
  // 站点-新增站点
  insertSiteInfo: "/dbs/api/site/insertSiteInfo",
  // 站点-建设场所
  constructionType: "/ant/v1/sys/dict/findDictDataByType?type=constructionType",
  // 站点-车辆品牌
  brandId: "/ant/v1/sys/dict/findDictDataByType?type=brandId",
  // 站点-支付方式
  payMod: "/ant/v1/sys/dict/findDictDataByType?type=payMod",
  // 站点-收费方式
  park: "/ant/v1/sys/dict/findDictDataByType?type=park",
  // 站点-站点类型
  siteType: "/ant/v1/sys/dict/findDictDataByType?type=siteType",
  // 站点-编辑站点信息
  getSiteDetailBySiteId: "/dbs/api/site/getSiteDetailBySiteId",
  // 站点-修改站点信息
  updateSiteInfo: "/dbs/api/site/updateSiteInfo",
  // 站点详情综合页面
  getSiteSimpleInfoById: "/dbs/api/site/getSiteSimpleInfoById",
  // 站点-修改站点状态
  updateSiteStatus: "/dbs/api/site/updateSiteStatus",
  // 站点模块，区域设置
  // 站点-新增区域
  insertRegion: "/dbs/api/region/insertRegion",
  // 站点-区域-根据站点id查询区域
  getRegionBySiteId: "/dbs/api/region/getRegionBySiteId",
  // 站点-区域- 删除
  deleteRegion: "/dbs/api/region/deleteRegion",
  // 站点-区域-编辑
  updateRegion: "/dbs/api/region/updateRegion",
  // 站点-站点导出
  exportSiteSimpleList: "/ant/api/site/exportSiteSimpleList",

  // 站点-分页获取设备列表
  getPagedBoxSimpleList: "/dbs/api/box/getPagedBoxSimpleList",
  // 站点-设备 根据桩号获取设备简单信息
  getBoxSimpleInfoBySerialNumber: "/dbs/api/box/getBoxSimpleInfoBySerialNumber",
  // 站点-解绑设备
  unActivateBoxInfo: "/dbs/api/box/unActivateBoxInfo",
  // 站点-绑定设备
  activateBoxInfo: "/dbs/api/box/activateBoxInfo",
  // 站点-设备 根据桩号获取设备简单信息
  getBoxSimpleInfoByDeviceId: "/dbs/api/box/getBoxSimpleInfoByDeviceId",
  // 站点-设备 根据枪头获取 信息列表
  getChargerInfoListByDeviceId: "/dbs/api/charger/getChargerInfoListByDeviceId",
  // 站点-设备 根据输入编号模糊查询地锁
  getLockLikeCode: "/dbs/api/lock/getLockLikeCode",
  // 站点-更新设备信息
  updateBoxInfo: "/dbs/api/box/updateBoxInfo",
  // 站点-根据枪头获取计费模版详情
  bindTemplateToConnector: "/dbs/api/template/bindTemplateToConnector",
  // 站点详情-设备统计信息
  getDeviceStatistics: "/dbs/api/box/getDeviceStatistics",
  // 站点详情-更新插座信息
  updateChargerInfo: "/dbs/api/charger/updateChargerInfo",
  // 站点详情-枪头监控饼状图
  getChargerStatusStatisticsBySiteId:
    "/dbs/api/charger/getChargerStatusStatisticsBySiteId",
  // 站点详情-公告
  queryNoticeBySite: "/ant/api/siteNotice/queryNoticeBySite",
  // 站点详情-新增公告
  addNotice: "/ant/api/siteNotice/addNotice",
  // 站点详情-值班表
  getSiteDuty: "/ant/api/siteDuty/getSiteDuty",
  // 站点详情-数据统计
  getSiteSurvey: "/ant/api/dataReport/getSiteSurvey",
  // 站点详情-数据统计(优化)
  getChargingTimesPowerAmount:
    "/ant/api/dataReport/getChargingTimesPowerAmount",
  // 站点-统计-根据站点统计指定时间段的充电次数、电量、金额、充电时长
  getSiteSum: "/ant/api/dataReport/getSiteSum",
  // 站点-统计-根据站点统计指定时间段的充电次数、电量、金额、充电时长(优化)
  getSiteStatisticsBar: "/ant/api/dataReport/getSiteStatisticsBar",
  // 站点-根据站点按照月份查询订单数据柱状图及环比同比数据
  queryOrderCountByMonth: "/ant/api/dataReport/queryOrderCountByMonth",
  // 站点-充电运营走势
  getSiteTrend: "/ant/api/dataReport/getSiteTrend",
  // 统计-站点下充电运营走势（优）
  getSiteOperatingTrend: "/ant/api/dataReport/getSiteOperatingTrend",
  // 站点-保存站点值班表
  saveSiteDuty: "/ant/api/siteDuty/saveSiteDuty",
  // 站点-定时充电
  querySiteTime: "/ant/api/siteSeting/querySiteTimeBox",
  // 站点-新增站点定时充电设置
  addSiteTime: "/ant/api/siteSeting/addSiteTime",
  // 站点-更新站点定时充电设置
  updateSiteTime: "/ant/api/siteSeting/updateSiteTime",
  // 站点-批量开启
  listStartCharger: "/ant/api/chargerorder/listStartCharger",
  // 站点-批量开启
  listStopCharger: "/ant/api/chargerorder/listStopCharger",

  // 上传图片
  uploadImg: "/ant/v1/sys/dict/upload",

  // 运维-获取枪头信息
  getPagedChargerInfoList: "/dbs/api/charger/getPagedChargerInfoList",
  // 运维-枪头详情-枪头订单
  queryChargerOrderListByConnectId:
    "/ant/api/order/queryChargerOrderListByConnectId",
  // 运维-枪头详情开启充电
  startCharger: "/ant/api/chargerorder/startCharger",
  // 运维-枪头详情停止充电
  stopCharger: "/ant/api/chargerorder/stopCharger",
  // 枪头详情 临时数据
  chargerTemporaryDate: "/ant/api/chargerTemporaryDate",
  // 批量开启充电
  batchOpen: "/ant/api/chargerorder/listStartCharger",
  batchClose: "/ant/api/chargerorder/listStopCharger",
  batchOpen2: "/ant/api/chargerorder/listStartChargerNotify",
  batchClose2: "/ant/api/chargerorder/listStopChargerNotify",

  // 大数据
  getOrderDataByMonth: "/ant/api/dataReport/getOrderDataByMonth",
  getNowYearOrderDataByMonth: "/ant/api/dataReport/getNowYearOrderDataByMonth",
  // 大数据-统计今年每个月订单相关数据（电量、实付金额、充电次数等）（优）
  getThisYearMonthlyOrderData:
    "/ant/api/dataReport/getThisYearMonthlyOrderData",
  // 车辆管理
  // 新增车辆信息
  insertVehicle: "/ant/api/vehicle/insertVehicle",
  // 更新车辆信息
  updateVehicle: "/ant/api/vehicle/updateVehicle",
  // 删除车辆
  deleteVehicleById: "/ant/api/vehicle/deleteVehicleById",
  // 车辆导入
  importVehicle: "/ant/api/vehicle/importVehicle",
  // 根据车辆Id查询车辆信息
  getVehicleById: "/ant/api/vehicle/getVehicleById",
  // 根据条件分页查询车辆列表
  queryVehiclePageList: "/ant/api/vehicle/queryVehiclePageList",
  // 大数据分析列表导出
  exportOrderDataByMonth: "/ant/api/dataReport/exportOrderDataByMonth",
  /// /////////////////////////////////////////////
  // 用户积分报表
  getAllClientIntegral: "/ant/api/userIntegral/queryAll",
  // 用户id查询积分报表
  getIntegralByUserId: "/ant/api/userIntegral/queryIntegralById",
  // 手机号查询积分报表
  getIntegralByPhone: "/ant/api/userIntegral/queryIntegralByPhone",
  // 用户积分详情
  getIntegralDetailListById: "/ant/api/userIntegral/queryIntegralRecord",
  /// /////////////////////////////////////////////能量调度
  // 变压器列表
  PMGetAllTrans: "/pms/api/transformer/queryAll",
  // 变压器列表 按站点
  PMGetTransBySite: "/pms/api/transformer/queryBySiteId",
  // 变压器详情
  PMTransDetail: "/pms/api/transformer/getTransformerById",
  // 新增变压器
  PMTransAdd: "/pms/api/transformer/add",
  // 变压器修改
  PMTransEdit: "/pms/api/transformer/update",
  // // 变压器删除
  // 'stationDelete': '/pms'
  // 枪列表
  PMGetAllDevice: "/pms/api/device/queryAll",
  // 根据变压器查枪
  PMGetDeviceByTrans: "/pms/api/device/queryByTransId",
  // 枪编辑
  PMDeviceEdit: "/pms/api/device/update",
  // 枪详情
  PMGetDeviceDetail: "/pms/api/device/getDeviceById",
  // 获取变压器调度数据
  PMDiscountSummary: "/pms/api/dispatch/getDispatchUtilization",
  // 获取变压器当前利用率
  PMTransUtilization: "/pms/api/transformer/getPowerUtilization",
  // 利用率列表
  PMGetDispatchByTrans: "/pms/api/dispatch/queryByTransId",
  // 利用率列表-根据设备id
  PMGetDispatchByDeviceId: "",
  // 利用率列表-根据调度id
  PMGetDispatchByDispId: "/pms/api/dispatchDevice/queryByDispatchId",
  // 查找场站枪
  PMGetAllDeviceBySite: "/pms/api/device/insertBcCode",
  // 查找场站已绑定变压器的枪
  PMGetBandedDevBySite: "/pms/api/device/getDeviceBanded",
  // 变压器绑定枪
  PMTransAddGun: "/pms/api/device/banding",
  /// /////////////////////////////////////////////////////优惠券 套餐 活动
  // 套餐列表
  getAllPackage: "/oms/api/chargePackage/queryPackage",
  // 新增套餐
  packageAdd: "/oms/api/chargePackage/addPackage",
  // 修改套餐
  packageUpdate: "/oms/api/chargePackage/updatePackage",
  // 套餐上下线
  updateOnlineStatus: "/oms/api/chargePackage/updateOnlineStatus",
  // 套餐id查询
  packageDetail: "/oms/api/chargePackage/getPackageNSiteById",
  // 优惠券列表
  getAllCoupon: "/oms/api/coupon/queryCoupon",
  // 优惠券新增
  couponAdd: "/oms/api/coupon/addCoupon",
  // 优惠券修改
  couponUpdate: "/oms/api/coupon/updateCoupon",
  // 优惠券修改
  updateCouponOnlineStatus: "/oms/api/coupon/updateCouponOnlineStatus",
  // 优惠券详情
  couponDetail: "/oms/api/coupon/getCouponNSiteById",
  // 优惠券详情（不包含站点）
  couponDetailSelf: "/oms/api/coupon/getCouponById",
  // 活动列表
  getAllActivity: "/oms/api/ActivityInfo/queryActivityByParam",
  // 活动新增
  activityAdd: "/oms/api/ActivityInfo/insertActivityInfo",
  // 活动编辑
  activityUpdate: "/oms/api/ActivityInfo/updateActivityInfo",
  // 活动详情
  activityDetail: "/oms/api/ActivityInfo/selectActivityById",
  // 活动列表
  getAllActivity2: "/oms/api/ActivityInfo/queryActivityByParam",
  // 活动新增
  activityAdd2: "/oms/api/ActivityInfo/addActivity",
  // 活动编辑
  activityUpdate2: "/oms/api/ActivityInfo/updateActivity",
  // 活动详情
  activityDetail2: "/oms/api/ActivityInfo/getActivityNSiteById",
  // 查询规则模板
  getAllRuleByCommid: "/oms/api/template/queryRuleTemplateByCommId",
  // 新增规则
  ruleAdd: "/oms/api/ruleCoupon/add",
  // 编辑规则
  ruleUpdate: "/oms/api/ruleCoupon/update",
  // 删除规则
  ruleCouponDelete: "/oms/api/ruleCoupon/delete",
  // 已绑定规则
  queryRuleCouponBanded: "/oms/api/ruleCoupon/queryRuleCouponBanded",
  // 查询活动绑定的业务
  activityRelateBusis: "/oms/api/ActivityInfo/queryBusinessByActivity",
  // 查询未绑定优惠券
  queryCouponByActivity: "/oms/api/ActivityInfo/queryCouponByActivity",
  // 查询未绑定套餐
  queryPackageByActivity: "/oms/api/ActivityInfo/queryPackageByActivity",
  // 查询未绑定积分商品
  queryCommodityByActivity: "/oms/api/ActivityInfo/queryCommodityByActivity",
  // 增加活动关联
  insertRelateActivity: "/oms/api/ActivityInfo/insertRelateActivity",
  // 删除活动关联
  deleteRelateActivity: "/oms/api/ActivityInfo/deleteRelateActivity",
  // 添加活动规则
  insertActivityRule: "/oms/api/ActivityInfo/insertRule",
  // 删除活动规则
  deleteActivityRule: "/oms/api/ActivityInfo/deleteRule",
  // 查询活动规则
  queryRuleByActivity: "/oms/api/ActivityInfo/queryRuleByActivity",
  // 向用户赠送优惠券
  addGetRecord: "/oms/api/couponGet/addGetRecord",
  /// //////////////////////////////////////////////////////////////
  // 财务数据同步
  // 站点列表
  selectSiteList: "/ant/api/finance/selectSiteList",
  // 维护站点信息
  saveSiteExt: "/ant/api/finance/saveSiteExt",
  // 获取站点详情信息
  selectSiteExtById: "/ant/api/finance/selectSiteExtById",
  // 异常订单列表
  selectErrorOrder: "/ant/api/finance/selectErrorOrder",
  // 修改异常订单
  updateOrderPrice: "/ant/api/finance/updateOrderPrice",
  // 站点订单合计信息
  selectSiteOrderTotal: "/ant/api/finance/selectSiteOrderTotal",
  // 同步数据到财务
  syncSiteOrderTotal: "/ant/api/finance/syncSiteOrderTotal",
  // 查询订单
  selectOrderByID: "/ant/api/finance/selectOrderByID",
  // 月末修改订单
  endMonthUpdateData: "/ant/api/finance/endMonthUpdateData",
  // 月末同步数据到财务
  endMonthSyncData: "/ant/api/finance/endMonthSyncData",
  // 订单异动记录
  selectEndMonthChange: "/ant/api/finance/selectEndMonthChange",
  // 同步记录
  selectSyncData: "/ant/api/finance/selectSyncData",
  // 同步记录导出
  exportSyncData: "/ant/api/finance/exportSyncData",
  // 报表-优惠券发送报表
  selectCouponGet: "/ant/api/couponChargeReport/selectCouponGet",
  // 报表-优惠券发放导出
  exportCouponGet: "/ant/api/couponChargeReport/exportCouponGet",
  // 报表-优惠券发放导出V1
  exportCouponGetV1: "/ant/api/couponChargeReport/exportCouponGetV1",
  // 报表-套餐购买报表
  selectPackageGet: "/ant/api/couponChargeReport/selectPackageGet",
  // 报表-套餐购买导出
  exportPackageGet: "/ant/api/couponChargeReport/exportPackageGet",
  // 报表-优惠券使用
  selectCouponUsed: "/ant/api/couponChargeReport/selectCouponUsed",
  // 报表-优惠券使用导出
  exportCouponUsed: "/ant/api/couponChargeReport/exportCouponUsed",
  // 报表-套餐使用报表
  selectPackageUsed: "/ant/api/couponChargeReport/selectPackageUsed",
  // 报表-套餐使用导出
  exportPackageUsed: "/ant/api/couponChargeReport/exportPackageUsed",
  // 发票-站点支持开票列表
  siteSupportInvoiceList: "/ant/api/invoice/selectSiteList",
  // 发票-站点支持开票详情
  siteSupportInvoiceDetail: "/ant/api/invoice/selectSiteById",
  // 发票-编辑站点支持开票状态
  siteSupportInvoiceSave: "/ant/api/invoice/saveSiteData",
  // 折扣组删除
  delDiscount: "/ant/api/discount/delDiscount",
  // 站点数据统计-刷新
  refreshOrderStatistics: "/ant/api/report/refreshOrderStatistics",
  // 站点数据统计-列表
  selectOrderStatistics: "/ant/api/report/selectOrderStatistics",
  // 站点数据统计-导出
  exportOrderStatistics: "/ant/api/report/exportOrderStatistics",

  // 查询事件
  getEvent: "/ant/api/eventSet/getEvent",
  // 事件绑定活动
  addEventAction: "/ant/api/eventSet/addEventAction",
  // 获取事件关联的活动
  getEventAction: "/ant/api/eventSet/getEventAction",
  // 删除相关的事件活动
  deleteEventAction: "/ant/api/eventSet/deleteEventAction",
  // 规则类型  1,活动 2优惠券
  selectRule: "/oms/api/rule/selectRule",
  // 规则详细类型
  queryRuleDetail: "/oms/api/rule/queryRuleDetail",
  // 已添加规则查询
  queryRelateRule: "/oms/api/RelateRule/queryRelateRule",
  // 添加规则
  insertRelateRule: "/oms/api/RelateRule/insertRelateRule",
  // 删除规则
  deleteRuleById: "/oms/api/RelateRule/deleteById",
  // 获取用户规则详情
  selectRuleById: "/oms/api/RelateRule/selectById",
  // 更新用户规则
  updateRuleById: "/oms/api/RelateRule/updateById",
  // 用户画像查询
  selectPersonas: "/ant/api/personas/selectPersonas",
  // 用户画像导出
  exportPersonas: "/ant/api/personas/exportPersonas",
  // 获取所有用户等级
  getAllLevel: "/ant/api/newUserLevel/getAllLevel",
  // 获取车辆细分类型
  getCarDetail: "/ant/api/userCar/getCarDetail",
  // 获取所有用户组
  getAllGroups: "/ant/api/newGroup/getAllGroups",
  // 手动发券
  addGetRecords: "/oms/api/couponGet/addGetRecords",
  // 对账总数据查询
  getReconciliationTotal: "/ant/api/reconciliation/getReconciliationTotal",
  // 对账总数据导出
  exportReconciliationTotal:
    "/ant/api/reconciliation/exportReconciliationTotal",
  // 对账明细（订单）
  exportReconciliationBill: "/ant/api/reconciliation/exportReconciliationBill",
  // 获取所有标签
  getsAllSiteTag: "/ant/api/tag/getsAllSiteTag",
  // 获取所有标签
  getAllSiteTags: "/ant/api/tag/getAllSiteTags",
  // 获取所有标签组
  getSiteTagGroup: "/ant/api/tag/getSiteTagGroup",
  // 新增
  saveSiteTag: "/ant/api/tag/saveSiteTag",
  // 修改
  updateSiteTag: "/ant/api/tag/updateSiteTag",
  // 删除
  deleteSiteTag: "/ant/api/tag/deleteSiteTag",
  // 电池检测列表
  queryBatteryList: "/ant/api/battery/queryBatteryList",
  // 导出电池检测列表
  exportBatteryList: "/ant/api/battery/exportBatteryList",
  // 电池检测详情
  getBatteryReport: "/ant/api/battery/getBatteryReport",
  // 电池检测图表详情
  getBatteryDuring: "/ant/api/battery/getBatteryDuring",

  // 商品列表
  commodityList: "/oms/api/commodity/queryCommodityList",
  // 下线
  commodityOff: "/oms/api/commodity/updateCommodityStatus",
  // 保存商品
  commodityAdd: "/oms/api/commodity/saveCommodity",
  // 商品详情
  commodityEdit: "/oms/api/commodity/getCommodityDetail",
  // 积分订单查询
  commodityOrder: "/oms/api/commodityOrder/queryCommodityOrderList",
  // 积分订单详情
  commodityOrderDetail: "/oms/api/commodityOrder/queryCommodityOrderDetail",
  // 积分订单核销
  writeOffOrder: "/oms/api/commodityOrder/writeOffOrder",
  // 积分订单导出
  exportCommodityOrderListV1:
    "/oms/api/commodityOrder/exportCommodityOrderListV1",

  // 导出文件列表
  queryDownLoadList: "/ant/api/sysDownload/queryDownLoadList",
  // 下载文件
  download: "/ant/api/sysDownload/download",
  // 站点订单导出
  exportStationOrderV1: "/ant/api/report/exportStationOrderV1",
  // 分时订单导出
  exportStationOrderDetailV1: "/ant/api/report/exportStationOrderDetailV1",

  // 导出套餐销售表
  exportPackageTotal: "/ant/api/reconciliation/exportPackageTotal",
  // 查询订单详情
  queryOrderRecordReport: "/ant/api/order/queryOrderRecordReport",
  // 导出用户车辆信息
  exportUserCarV1: "/ant/api/report/exportUserCarV1",
  // 导出新场站数据
  exportOrderMonthSumListNew: "/ant/api/report/exportOrderMonthSumListNew",

  // app设置
  findSysConfig: "/ant/api/sys/findSysConfig",
  // 上传图片
  upload: "/ant/api/sys/upload",
  // 保存设置
  saveSysConfig: "/ant/api/sys/saveSysConfig",

  // 数据可视化
  selectSiteRatioStatistics: "/ant/api/orderReport/selectSiteRatioStatistics",
  selectSitePersonasRatioStatistics:
    "/ant/api/personas/selectSitePersonasRatioStatistics",

  // 道闸
  saveParkTemplate: "/oms/api/park/saveParkTemplate",
  queryParkTemplate: "/oms/api/park/queryParkTemplate",
  queryParkTemplateById: "/oms/api/park/queryParkTemplateById",
  saveParkBaseInfo: "/oms/api/park/saveParkBaseInfo",
  queryParkBaseInfo: "/oms/api/park/queryParkBaseInfo",
  queryParkBaseInfoById: "/oms/api/park/queryParkBaseInfoById",
  queryParkRecord: "/oms/api/park/queryParkRecord",
  queryParkCoupon: "/oms/api/park/queryParkCoupon",
  queryParkChargerRecord: "/oms/api/park/queryParkChargerRecord",
  queryParkOperatorList: "/oms/api/park/queryParkOperatorList",

  // 发票
  selectRechargersByBlocId: "/ant/api/invoice/selectRechargersByBlocId",
  updateRechargeStatus: "/ant/api/invoice/updateRechargeStatus",

  // BI
  querySiteConfigList: "/oms/api/siteConfig/querySiteConfigList",
  getSiteConfigById: "/oms/api/siteConfig/getSiteConfigById",
  saveSiteConfig: "/oms/api/siteConfig/saveSiteConfig",
  delSiteConfig: "/oms/api/siteConfig/delSiteConfig",
  querySiteConfigPrepareList: "/oms/api/siteConfig/querySiteConfigPrepareList",
  getSiteConfigPrepareById: "/oms/api/siteConfig/getSiteConfigPrepareById",
  saveSiteConfigPrepare: "/oms/api/siteConfig/saveSiteConfigPrepare",
  delSiteConfigPrepare: "/oms/api/siteConfig/delSiteConfigPrepare",

  // 黑卡会员
  queryMemberCard: "/oms/api/memberCard/queryMemberCard",
  saveMemberCard: "/oms/api/memberCard/saveMemberCard",
  saveMemberCardDetail: "/oms/api/memberCard/saveMemberCardDetail",
  saveMemberCardRight: "/oms/api/memberCard/saveMemberCardRight",
  queryMemberCardDetail: "/oms/api/memberCard/queryMemberCardDetail",
  selectOrderDiscount: "/ant/api/couponChargeReport/selectOrderDiscount",
  exportOrderDiscount: "/ant/api/couponChargeReport/exportOrderDiscount",
  queryMemberCardOrderList: "/oms/api/commodityOrder/queryMemberCardOrderList",
  exportMemberCardOrder: "/oms/api/commodityOrder/exportMemberCardOrder",

  // 推广码
  querySaler: "/oms//api/saler/querySaler",
  addSaler: "/oms//api/saler/addSaler",
  getSaler: "/oms//api/saler/getSaler",
  updateSaler: "/oms//api/saler/updateSaler",
  createSalerInvite: "/oms//api/saler/createSalerInvite",
  querySalerInviteList: "/oms//api/saler/querySalerInviteList",
  getSalerInvite: "/oms/api/saler/getSalerInvite",
  querySalerInviteRecordList: "/oms//api/saler/querySalerInviteRecordList",
  inviteType: "/ant/v1/sys/dict/findDictDataByType?type=inviteType", // 推广类型 字典

  // 抽奖
  queryPrizeInfoList: "/oms/api/prize/queryPrizeInfoList",
  addPrizeInfo: "/oms/api/prize/addPrizeInfo",
  getPrizeInfo: "/oms/api/prize/getPrizeInfo",
  updatePrizeInfo: "/oms/api/prize/updatePrizeInfo",
  queryPrizeRecordList: "/oms/api/prize/queryPrizeRecordList",
  queryPrizeByActivity: "/oms/api/ActivityInfo/queryPrizeByActivity",

  // 站点评论
  querySiteChargerCommentStatistics:
    "/ant/api/comment/querySiteChargerCommentStatistics",
  updateSiteComment: "/ant/api/comment/updateSiteComment",

  // 查询客户消费
  getBlocWalletAndAmount: "/ant/api/rblocUser/getBlocWalletAndAmount",

  // 客户报表导出V1
  exportUserMonthOrderV1: "/ant/api/report/exportUserMonthOrderV1",
  // 报表-优惠券使用导出V1
  exportCouponUsedV1: "/ant/api/couponChargeReport/exportCouponUsedV1",
  // 报表-套餐使用导出V1
  exportPackageUsedV1: "/ant/api/couponChargeReport/exportPackageUsedV1",
  // 用户画像导出V1
  exportPersonasV1: "/ant/api/personas/exportPersonasV1",

  // 站点评论用户信息
  querySiteChargerCommentUsers: "/ant/api/comment/querySiteChargerCommentUsers",
  // 站点评论用户信息导出
  exportSiteChargerCommentUsers:
    "/ant/api/comment/exportSiteChargerCommentUsers",
  // BI导入
  importSiteConfigPrepare: "/oms/api/siteConfig/importSiteConfigPrepare",

  // 定时下发计费模板
  listScheduleJob: "/oms/api/job/listScheduleJob",
  // 定时下发计费模板
  saveScheduleJob: "/oms/api/job/saveScheduleJob",
  // 定时下发计费模板
  updateScheduleJob: "/oms/api/job/updateScheduleJob",
  // 定时下发计费模板
  deleteScheduleJob: "/oms/api/job/deleteScheduleJob",
  // 定时下发计费模板
  getScheduleJobById: "/oms/api/job/getScheduleJobById",

  // hlht 设备运营商列表
  hlhtDeviceList:'/hlht/api/operatorInfo/deviceList',
  // 导出积分列表
  exportAllIntegral:'/ant/api/userIntegral/exportAllIntegral',

  // 积分报表
  selectSumIntegral:'/ant/api/userIntegral/selectSumIntegral',
  // 导出积分报表
  exportSumIntegral:'/ant/api/userIntegral/exportSumIntegral',
  //积分报表
  queryUserIntegralAll:'/ant/api/userIntegral/queryAll',
  // 互联互通设备运营商列表
  deviceOperatorList: '/hlht/api/operatorInfo/deviceList',

  
  // 解绑用户微信
  unlockWxBind:'/ant/api/user/unlockWxBind',
  // 更换用户手机号
  changePhone:'/ant/api/user/changePhone',
  // 社群二维码
  setAssociationQrCode:'/ant/api/sys/setAssociationQrCode',
  // 发票重开
  redoInvoice:'/ant/api/invoice/redoInvoice',
  // 占位费订单列表
  listUserChargerOrderHolding:'/ant/api/user/listUserChargerOrderHolding',
   // 取消占位费
  cancelChargerHoldingOrder :'/ant/api/order/cancelChargerHoldingOrder',
};



// WEBPACK FOOTER //
// ./src/apiPath/api.js